import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "./Travel_Explore_Banner.css";

const Travel_Explore_Banner = () => {
  const slides = [
    "/assets/images/footer/travel_explore.png",
    "/assets/images/footer/travel_explore.png",
    "/assets/images/footer/travel_explore.png",
  ];

  return (
    <section className="travel_explore_banner">
      <Swiper
        modules={[Pagination, Autoplay]}
        effect="fade"
        speed={1200}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
        }}
      >
        {slides.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="image_wrapper">
              <img src={image} alt={`slide-${index}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Pagination */}
      <div className="custom-pagination"></div>
    </section>
  );
};

export default Travel_Explore_Banner;
